module.exports = __webpack_public_path__ + "static/media/list.ef7bc3b8.svg";